const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2d2582d-12a4-4488-aca2-09d1b2d38e6b",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.99 15.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Orders") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,15.76H1.5v-12h2v.5a.5.5,0,0,0,.5.5H9a.5.5,0,0,0,.5-.5v-.5h2Zm-7-13h1a.5.5,0,0,0,.5-.5.5.5,0,0,1,1,0,.5.5,0,0,0,.5.5h1v1h-4Zm7,0h-2v-.5a.5.5,0,0,0-.5-.5H7.91a1.49,1.49,0,0,0-2.82,0H4a.5.5,0,0,0-.5.5v.5h-2a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-12a1,1,0,0,0-1-1Z",
    transform: "translate(-0.5 -0.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.77H8a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h2a.51.51,0,0,0,.5-.5A.5.5,0,0,0,10,11.77Z",
    transform: "translate(-0.5 -0.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,7.77H8a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5h2a.51.51,0,0,0,.5-.5A.5.5,0,0,0,10,7.77Z",
    transform: "translate(-0.5 -0.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35,10.91a.5.5,0,0,0-.7,0L4,12.56l-.64-.65a.51.51,0,0,0-.71,0,.5.5,0,0,0,0,.68l1,1a.5.5,0,0,0,.7,0h0l2-2a.51.51,0,0,0,0-.71Z",
    transform: "translate(-0.5 -0.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35,6.92a.49.49,0,0,0-.7,0L4,8.56l-.64-.65a.5.5,0,0,0-.71,0,.49.49,0,0,0,0,.69l1,1a.51.51,0,0,0,.71,0l2-2a.48.48,0,0,0,0-.7Z",
    transform: "translate(-0.5 -0.77)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.2f9288bd9e4aba70db283ddc5c58ead4.svg";
export { ForwardRef as ReactComponent };